import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getQueryMinStarRating } from 'store/router/routerSelectors';
import { updateQuery as updateQueryAction } from 'store/search/searchActions';
import StarRatingFilter from 'components/Filters/Search/RatingFilter/StarRatingFilter';

import FilterItem from './FilterItem';

const StarRatingFilterItem = () => {
  const dispatch = useDispatch();
  const minStarRating = useSelector(getQueryMinStarRating);

  const updateQuery = useCallback(
    (query) => {
      dispatch(updateQueryAction(query));
    },
    [dispatch],
  );

  const clearFilters = useCallback(() => {
    updateQuery({ minStarRating: undefined });
  }, [updateQuery]);

  return (
    <FilterItem buttonText="Hotel Rating" isHighlighted={!!minStarRating} clearFilters={clearFilters}>
      <StarRatingFilter onChange={updateQuery} />
    </FilterItem>
  );
};

export default StarRatingFilterItem;
